import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { ConfigFieldsProps } from "./types";

export function GanttConfig({
  editedComponent,
  updateConfig,
  pageComponents,
}: ConfigFieldsProps) {
  const linkedTableFilters = pageComponents.filter(
    (c) =>
      c.type === "filter" &&
      c.config?.optionsSource === "linkedTable" &&
      c.config?.field,
  );

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="ganttTitle">Título</Label>
        <Input
          id="ganttTitle"
          type="text"
          value={editedComponent.config.title || "Cronograma"}
          onChange={(e) => updateConfig("title", e.target.value)}
          placeholder="Cronograma"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ganttZoomMode">Modo de visualização inicial</Label>
        <Select
          value={editedComponent.config.defaultZoomMode || "days"}
          onValueChange={(value) => updateConfig("defaultZoomMode", value)}
        >
          <SelectTrigger id="ganttZoomMode">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="days">Dias</SelectItem>
            <SelectItem value="weeks">Semanas</SelectItem>
            <SelectItem value="months">Meses</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="ganttViewMonths">Meses visíveis (modo Dias)</Label>
        <Select
          value={String(editedComponent.config.viewMonths || 2)}
          onValueChange={(value) => updateConfig("viewMonths", Number(value))}
        >
          <SelectTrigger id="ganttViewMonths">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1">1 mês</SelectItem>
            <SelectItem value="2">2 meses</SelectItem>
            <SelectItem value="3">3 meses</SelectItem>
            <SelectItem value="6">6 meses</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="ganttEditable"
          checked={editedComponent.config.editable !== false}
          onChange={(e) => updateConfig("editable", e.target.checked)}
          className="w-4 h-4 rounded"
        />
        <Label htmlFor="ganttEditable" className="cursor-pointer">
          Permitir adicionar/editar tarefas
        </Label>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="ganttShowProgress"
          checked={editedComponent.config.showProgress !== false}
          onChange={(e) => updateConfig("showProgress", e.target.checked)}
          className="w-4 h-4 rounded"
        />
        <Label htmlFor="ganttShowProgress" className="cursor-pointer">
          Mostrar barra de progresso nas tarefas
        </Label>
      </div>

      <div className="space-y-2 border-t pt-4 mt-2">
        <Label htmlFor="ganttFilterField">Filtrar tarefas por Tabela Vinculada</Label>
        <Select
          value={editedComponent.config.filterField || "__none__"}
          onValueChange={(value) =>
            updateConfig("filterField", value === "__none__" ? undefined : value)
          }
        >
          <SelectTrigger id="ganttFilterField">
            <SelectValue placeholder="Nenhum filtro selecionado" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__none__">Nenhum (mostrar todas as tarefas)</SelectItem>
            {linkedTableFilters.length === 0 ? (
              <SelectItem value="_empty" disabled>
                Nenhum filtro "Tabela Vinculada" nesta página
              </SelectItem>
            ) : (
              linkedTableFilters.map((f) => (
                <SelectItem key={f.id} value={f.config.field}>
                  {f.config?.title || `Filtro (${f.config.field})`}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Cada tarefa pode ser vinculada a uma tabela (na própria modal de
          cadastro). Selecionando aqui um filtro "Tabela Vinculada" da
          página, o cronograma mostra apenas as tarefas da tabela escolhida
          nesse filtro.
        </p>
      </div>

      <div className="p-4 bg-accent border border-primary/20 rounded-md">
        <p className="text-sm">
          <strong>📅 Sobre o Cronograma:</strong>
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          As tarefas são gerenciadas diretamente no componente. Use os modos
          Dias, Semanas ou Meses para diferentes níveis de detalhe.
        </p>
      </div>
    </>
  );
}
